<modal
  [id]="id()"
  [header]="'Clone persona'"
  [closeButtonEnabled]="!isSubmitting()"
  [showHeaderDivider]="true"
  [showFooterDivider]="false"
  [widthClass]="'tw-w-11/12 tw-max-w-xl'"
  [heightClass]="'tw-h-auto'"
  [enableBackdropClose]="!isSubmitting()"
  [escapeToClose]="!isSubmitting()"
  (onCloseModal)="handleModalClose()"
  [headerIcon]="cloneIcon"
>
  <div slot="body">
    <basic-input
      [control]="personaName"
      [label]="'Persona name'"
      [placeholder]="'Persona name'"
      [autofocus]="true"
      (onKeydown)="onFieldKeydown($event)"
    ></basic-input>

    <basic-input
      [control]="personaSlug"
      [label]="'URL identifier'"
      [placeholder]="'URL identifier'"
      (onKeydown)="onFieldKeydown($event)"
    ></basic-input>
    <p class="tw-mt-1.5 tw-mb-4 tw-break-all tw-rounded-xl tw-bg-gray-50 tw-px-3 tw-py-4 tw-text-sm tw-leading-6 tw-text-gray-500 tw-border tw-border-gray-300">
      {{ registrationUrl() }}
    </p>
  </div>
  <div class="tw-flex tw-justify-center tw-items-center tw-gap-2 tw-px-6 tw-pb-6" slot="footer">
    <button
      type="button"
      class="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-w-full tw-text-white tw-bg-blue-600 hover:tw-bg-blue-700 tw-font-medium tw-rounded-xl tw-text-sm tw-px-5 tw-py-3 tw-transition-colors"
      (click)="onConfirm()"
    >
      @if (isSubmitting()) {
        <progress-circle [isInfinite]="true" class="tw-inline-flex tw-scale-75" colorClasses="tw-border-white tw-border-r-blue-200"></progress-circle>
      }
      Confirm
    </button>
  </div>
</modal>
